"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("../../elements/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ActionBtn = (0, _styledComponents.default)(_Button.default).attrs(({
  modifiers
}) => ({
  modifiers: ['small'].concat(modifiers)
})).withConfig({
  displayName: "ActionBtn"
})(["margin-left:1.25rem;"]);
var _default = ActionBtn;
exports.default = _default;